/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

export function formatServiceName(service: {
  name?: string;
  version?: string;
}) {
  return [service?.name, service?.version && `[${service.version}]`]
    .filter(Boolean)
    .join(" ");
}
